import { EventEmitter } from "events";

const EventBus = new EventEmitter();
export default EventBus;
